import { initializeApp } from 'firebase/app'
import {
  getAuth,
  User,
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const app = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
})

const auth = getAuth(app)

const signInWithGoogle = (callback: () => void) => {
  const provider = new GoogleAuthProvider()
  signInWithPopup(auth, provider).then(callback)
}

const firestore = getFirestore(app)

export { auth, signInWithGoogle, firestore }
export type { User }
